import { useTranslation as useI18nTranslation } from "react-i18next";

/**
 * i18n 번역을 위한 훅
 * react-i18next의 useTranslation을 래핑하여 타입 안전성을 제공
 */
export function useTranslation() {
  const { t, i18n } = useI18nTranslation();

  return {
    t, // 번역 함수
    i18n, // i18n 인스턴스
    currentLanguage: i18n.language as "ko" | "en",
  };
}

/**
 * 간단한 번역을 위한 훅
 * 키를 받아서 번역된 문자열을 반환
 */
export function useT() {
  const { t } = useI18nTranslation();
  return t;
}
